import { Checkbox } from "@mui/material";
import { memo } from "react";

const CheckboxSeleccionBase = ({ idProfesional, idLiquidacion, checked, disabled, onToggle }) => (
    <Checkbox
        size='small'
        disabled={disabled}
        checked={checked}
        onChange={() => onToggle(idProfesional, idLiquidacion)}
    />
);

export const CheckboxSeleccion = memo(CheckboxSeleccionBase);